import React from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  NavLink,
} from "reactstrap";

import { forgetPasswordEmailThunkAction } from "redux/user/action";
import { selectUser } from "redux/user/selector";

const ForgotPassword = () => {
  const [email, setEmail] = React.useState("");
  const dispatch = useDispatch();
  const { isSubmiting } = useSelector(selectUser);
  const history = useHistory();

  const navigateToHome = () => {
    history.push("/auth/verifyotp");
  };
  const submitHadler = (e) => {
    e.preventDefault();

    if (email === "") {
      toast.error("Please enter your email.");
      return;
    }

    dispatch(forgetPasswordEmailThunkAction(email, navigateToHome));
  };
  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-1">
          <h3 className="text-muted text-center mt-3">Forgot Password</h3>
          <CardBody className="px-lg-5 py-lg-5">
            <Form role="form" onSubmit={submitHadler}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    required
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
              </div>
              <div className="text-center">
                <Button
                  className="my-4"
                  color="dark"
                  type="submit"
                  disabled={isSubmiting ? true : false}
                >
                  {isSubmiting ? "Submiting..." : "Submit"}
                </Button>
                <NavLink to="/auth/login" tag={Link}>
                  <small
                    className="nav-link-inner--text"
                    style={{ color: "#000000" }}
                  >
                    Sign in?
                  </small>
                </NavLink>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ForgotPassword;
